"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var CaptchaApi = /** @class */ (function () {
    function CaptchaApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 获取人机验证码
     * @method GET 获取人机验证码
     *
     */
    CaptchaApi.prototype.Captcha = function () {
        return this.http
            .url("/api/Captcha")
            .support('GET');
    };
    /**
     * 发送手机验证码并返回签名
     * @method POST 发送手机验证码并返回签名
     *
     * @params phoneNumber 无说明
     */
    CaptchaApi.prototype.phoneByPhoneNumber = function (phoneNumber) {
        return this.http
            .url("/api/Captcha/phone/" + phoneNumber)
            .support('POST');
    };
    CaptchaApi.diOptions = di_1.default.options({
        name: "CaptchaApi",
        scope: "Singleton"
    });
    return CaptchaApi;
}());
exports.CaptchaApi = CaptchaApi;
exports.default = CaptchaApi;
